import {themeGetter} from 'quickstart/system'

const getHeadlines = (theme: any) => {
  const th = themeGetter(theme)
  return {
    default: {
      body: {
        borderTopColor: th('colors.borderColor'),
        borderTopStyle: 'solid',
        borderTopWidth: th('borderWidths.sm'),
      },
      heading: {
        ...th('fonts.heading'),
        ...th('prose.headlineHead'),
        marginTop: 'var(--evergreen-line-height)',
      },
    },
  }
}

export default getHeadlines
